import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Core2Config} from '../../shared/core2Config';
import {VoucherV2ContainerModel} from '../../../../../../models/aggregates/erp/coupon';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import { ApiResponseModel, ApiVisa } from '../../shared';

@Injectable({providedIn: 'root'})
export class VoucherVersion2Service extends BaseApiPublicLoginTemplateService<VoucherV2ContainerModel, VoucherV2ContainerModel, VoucherV2ContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/backoffice-ep';
    this.httpClient = http;
  }

  getUsedCouponsLoginEntity(serverDocType: string, visa: ApiVisa) {
    let endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'vouchers/used-vouchers/login-entity-ep?serverDocType=' + serverDocType;
    let url = Core2Config.DOMAIN_URL + endpoint_path;
    if (visa.api_domain_url) {
      url = visa.api_domain_url + endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<VoucherV2ContainerModel>>(url, this.getHttpHeader(visa));
  }

}
